import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { isLightTheme } from 'lib/themes/theme';
import { expandTheme } from 'utils/theme-util';
import colors from '../../../lib/themes/colors.module.scss';
import darkColors from '../../../lib/themes/dark-colors.module.scss';

const colorScheme = isLightTheme() ? colors : darkColors;

export const TasksStyles = (theme: Theme) => {
  const { palette, font } = expandTheme(theme);
  return createStyles({
    container: {
      padding: theme.spacing(1),
      backgroundColor: palette.primary.background,
    },
    tabPanel: {
      backgroundColor: 'primary.darkSteelGrey',
    },
  });
};

export const Styles = {
  tab: {
    backgroundColor: colorScheme.formItem,
    borderRadius: '4px 4px 0 0',
    marginRight: '7px',
    border: '1px solid',
    borderColor: 'primary.silverMist',
    position: 'relative',
    paddingTop: '11px',
  },
  selectedTab: {
    backgroundColor: colorScheme.lightSilver,
    marginRight: '7px',
    borderRadius: '4px 4px 0 0',
    borderTop: '1px solid',
    borderLeft: '1px solid',
    borderRight: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'primary.silverMist',
    borderBottomColor: 'primary.background',
    position: 'relative',
    zIndex: 1,
    paddingTop: '11px',
  },
  formsContainer: {
    border: '1px solid',
    borderColor: 'primary.silverMist',
    borderRadius: '0 0 4px 4px',
    position: 'relative',
    bottom: '1px',
  },
  tabsStyles: {
    '.MuiBox-root': {
      backgroundColor: colorScheme.lightSilver,
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    'border': null,
  },
  tabText: {
    color: 'primary.grey12',
    fontSize: 12,
    fontWeight: 'bold',
  },
  tabTextSelected: {
    color: 'primary.trellisBlue',
    fontSize: 12,
    fontWeight: 'bold',
  },
  tabPanel: {
    backgroundColor: colorScheme.lightSilver,
  },
};
